import React from 'react';
import { TermsAndConditions } from '@medtrail/shared-ui';
import Header from '../../components/header';
import { ROUTE_FLAG, WEBSITE } from '../../constants';


const termsAndCondition = () => {

  return (
    <React.Fragment>
      <div className='headerContainer'>
        <Header active={null} routeFlag={ROUTE_FLAG.paymentPolicyPage}/>
      </div>
      <TermsAndConditions website={WEBSITE}/>
    </React.Fragment>
  );

};

export default termsAndCondition;
